import { Injectable, inject } from "@angular/core";
import { HttpErrorDto } from "src/app/core/dto/shared/api-response.dto";
import { MessageService } from "primeng/api";

@Injectable({ providedIn: "root" })
export class NotificationsService {
    private _messageService: MessageService = inject(MessageService);

    displayHttpError(error: HttpErrorDto, customMessage?: string, life = 3000) {
        const errorMessage = customMessage || this.parseErrorMessage(error);

        this._messageService.add({
            severity: "error",
            life: life,
            summary: "Error",
            detail: errorMessage,
            key: "glToast",
        });
    }

    displayMessage(
        summary: string,
        detail: string,
        severity: string,
        life?: number,
    ) {
        this._messageService.add({
            severity: severity,
            life,
            summary,
            detail,
            key: "glToast",
        });
    }

    displayError(summary: string, detail: string, life = 3000) {
        this._messageService.add({
            severity: "error",
            life,
            summary,
            detail,
            key: "glToast",
        });
    }

    displaySuccess(summary: string, detail: string, life = 3000) {
        this._messageService.add({
            severity: "success",
            summary,
            detail,
            life,
            key: "glToast",
        });
    }

    displayInfo(summary: string, detail: string, life: number = 3000) {
        this._messageService.add({
            severity: "info",
            summary,
            detail,
            life,
            key: "glToast",
        });
    }

    displayWarn(summary: string, detail: string, life: number = 3000) {
        this._messageService.add({
            severity: "warn",
            summary,
            detail,
            life,
            key: "glToast",
        });
    }

    private parseErrorMessage(error: HttpErrorDto | any): string {
        if (error instanceof HttpErrorDto || (error && error.message)) {
            return error.message;
        } else if (error && error.error && typeof error.error === "string") {
            return error.error;
        } else {
            return "An unexpected error occurred.";
        }
    }
}
